import React, { useEffect, useState } from 'react';
import { useFingotiAuth } from '@fingoti/auth-js/react';
import { FingotiLoading } from '@fingoti/components';

import { setAuth } from '../../services/authConfig';

export const AuthBridge = ({ children }) => {
    const { auth, isLoading } = useFingotiAuth();
    const [bridged, setBridged] = useState(false);

    useEffect(() => {
        setAuth(auth);
        setBridged(true);
    }, [auth]);

    if (!bridged || isLoading) {
        return <FingotiLoading fullHeight />;
    }

    return children;
};
